var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicGroupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    fill: "black",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.2099V16.2679C17.6187 16.0478 17.1754 15.9596 16.7389 16.0171C16.3024 16.0746 15.8971 16.2745 15.5858 16.5858C15.2745 16.8971 15.0746 17.3025 15.0171 17.739C14.9596 18.1755 15.0478 18.6187 15.268 19C15.4881 19.3813 15.8279 19.6793 16.2347 19.8478C16.6414 20.0162 17.0924 20.0458 17.5177 19.9318C17.9429 19.8179 18.3187 19.5668 18.5867 19.2175C18.8547 18.8682 19 18.4402 19 17.9999V7.92594C19.0002 7.79758 18.9694 7.67106 18.9104 7.55708C18.8513 7.4431 18.7657 7.34499 18.6608 7.27105C18.5559 7.19711 18.4347 7.14951 18.3075 7.13226C18.1803 7.11501 18.0508 7.12862 17.93 7.17194L11.53 9.45794C11.3749 9.51357 11.2407 9.61576 11.1458 9.75054C11.0509 9.88532 11 10.0461 11 10.2109V17.2669C10.6188 17.0468 10.1755 16.9587 9.73907 17.0161C9.3026 17.0735 8.89728 17.2734 8.58596 17.5846C8.27463 17.8959 8.0747 18.3011 8.01716 18.7376C7.95962 19.174 8.04769 19.6173 8.26771 19.9986C8.48774 20.3799 8.82742 20.6779 9.23409 20.8465C9.64076 21.0151 10.0917 21.0448 10.517 20.931C10.9422 20.8172 11.3181 20.5663 11.5862 20.2172C11.8543 19.868 11.9998 19.4402 12 18.9999V13.3529L18 11.2109V11.2099Z",
    fill: "#FFCA3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicGroupIcon);
export default __webpack_public_path__ + "static/media/music-group-icon.f00eba4190dff666e6c6088f6879baf4.svg";
export { ForwardRef as ReactComponent };